import styled, { css, keyframes } from 'styled-components';
import theme from '../../theme';

const FadeIn = keyframes`
  from {top: 0; opacity: 0;}
  to {top: 15px; opacity: 1;}
`;

const FadeOut = keyframes`
  from {top: 15px; opacity: 1;}
  to {top: 0; opacity: 0;}
`;

const Container = styled.div<{
    $authLayout: boolean;
    $lp: boolean;
    $success: boolean;
    $error: boolean;
    $ms: number;
}>`
    position: fixed;
    z-index: 12;
    width: calc(100% - 50px);
    max-width: calc(600px - 50px);
    margin-left: 25px;
    border-radius: 8px;
    padding: 18px 0;
    top: 15px;
    -webkit-animation: ${FadeIn} 1s, '${FadeOut} 1s ${({ $ms }) => $ms / 1000}s';
    animation: ${FadeIn} 1s, ${FadeOut} 1s '${({ $ms }) => $ms / 1000}s';
    font-size: 14px;
    font-weight: 700;
    color: ${theme.white};
    text-align: center;

    ${props => props.$authLayout && css`
      width: calc(100% - 80px);
      max-width: calc(600px - 80px);
      margin-left: 0;
    `}

    ${props => props.$lp && css`
      margin-left: 0;
    `};

    ${props => props.$success && css`
      background-color: ${theme.successColor};
    `}

    ${props => props.$error && css`
      background-color: ${theme.errorColor};
    `}
`;

export { Container };